<template>
  <tr v-if="item.Element != 'NNH2'" class="item" :data-nutrient="item.Element" >
    <td :class="{disabled : loading}">
      <app-sel
        class="drainage-nut-app-sel"
        styling="inline"
        v-if="item.types"
        v-model="selected"
        :items="item.types"
        key-name="label"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            :value="nut"
            v-for="nut in items"
          >
            {{ nut.label }}
          </app-sel-opt>
        </template>
      </app-sel>

      <div class="as-default" v-else>
        {{ item.Element }}
      </div>
      <div></div>

    </td>

    <td :class="{disabled : loading}" class="side nut" v-if="item.units">
      <app-sel
        class="drainage-nut-app-sel"
        styling="inline"
        v-model="selectedUnit"
        key-name="label"
        :items="Object.keys(item.units).map(n => { return { label: n } })"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            :value="unit"
            v-for="unit in items"
            v-if="unit.label == 'ppm' || unit.label == 'mmol' || unit.label == 'mg/L' || unit.label == 'meq/L'"
          >
            {{ $ml.get(unit.label) }}
          </app-sel-opt>
        </template>
      </app-sel>
    </td>
    
      <td :class="{disabled : loading}">
          <app-number-input
            class="in-st drip drainage-num-input"
            :class="{readonly: disabled}"
            :placeholder="$ml.get(`Enter value`)"
            :value="convert(item.IrrigationWater)"
            :digits-after-dot="1"
            :step="0.1"
            @input="updateIrrigation"
            :readonly="disabled"
        />
      </td>

      <td :class="{disabled : loading}">
          <app-number-input
            class="in-st drain drainage-num-input"
            :class="{readonly: disabled}"
            :placeholder="$ml.get(`Enter value`)"
            :value="convert(item.DrainageAnalysis)"
            @input="updateDrainageAnalysis"
            :readonly="disabled"
        />
      </td>
      
      <td :class="{disabled : loading}">
          <app-number-input
            :readonly="true"
            class="in-st result drainage-num-input"
            :digits-after-dot="1"
            :step="0.1"
            :value="convert(item.TargetValues)"
        />
      </td>

      <!-- <app-number-input
        v-else
        class="in-st"
        :placeholder="$ml.get(`Enter value`)"
        v-model="item.value"
      /> -->
    <!-- </div> -->
    <LoadingSVG v-show="loading" class="table-loader" />
  </tr>
</template>

<script>
import { NutrientConverter } from '@/mixins/nutrient-converter.mixin';
import { UnitConverter } from '@/mixins/unit-converter.mixin';
import API from '@/api';
import { mapGetters } from 'vuex';
import LoadingSVG from '@/components/ui/LoadingSVG'


export default {
    data() {
       return {
           selectedUnit: 'ppm',
           selected: null,
           loading: false
       }
    },
    components: {LoadingSVG},
    mixins: [ NutrientConverter, UnitConverter ],
    props: {
        item: {

        },
        disabled: {
          default: false,
          required: false
        }
    },
    computed: {
      ...mapGetters({
        drainage: 'drainage/data',
      })
    },
    methods: {
      updateIrrigation(val) {
        val = this.unconvertNutrientType(this.item.Element, this.selected, val);
        let originalVal = this.item.IrrigationWater;
        this.item.IrrigationWater = this.toPpm(this.item.Element, this.selectedUnit, val);
        this.setValue(this.item.IrrigationWater, 'IrrigationWater', this.item.Element)
        if(originalVal != this.item.IrrigationWater) this.updateValues();
      },
      updateDrainageAnalysis(val) {
        val = this.unconvertNutrientType(this.item.Element, this.selected, val);
        let originalVal = this.item.DrainageAnalysis;
        this.item.DrainageAnalysis = this.toPpm(this.item.Element, this.selectedUnit, val);
        this.setValue(this.item.DrainageAnalysis, 'DrainageAnalysis', this.item.Element)
        if(originalVal != this.item.DrainageAnalysis) this.updateValues();
      },
      updateValues(type, val) {
        this.$emit('showLoader', {
          loading: true,
          el: this.item.Element
        });
        this.loading = true

        const requestData = {
          DrainageData: {
            Ph: this.drainage.drainageDataPh,
            Ec: this.drainage.drainageDataEc
          },
          DripData: {
            Ph: this.drainage.dripDataPh,
            Ec: this.drainage.dripDataEc
          },
          DrainagePercentage: this.drainage.drainagePercentage,
          InterpretationRequest: [{
            DrainageAnalysis: this.item.DrainageAnalysis,
            Element: this.item.Element,
            IrrigationWater: this.item.IrrigationWater
          }]
        }

        

        API.drainage.calculateValues(requestData).then(res => {
          this.item.TargetValues = res.data.data.RecommendedInterpretation[0].TargetValues
          this.setValue(this.item.TargetValues, 'TargetValues', this.item.Element)
        }).finally(() => {
          this.$emit('showLoader', {
            loading: false,
            el: this.item.Element
          });
          this.loading = false
        })
      },
        convert(value) {
          if(this.selected != this.item.Element && this.item.types) {
            value = this.convertNutrientType(this.item.Element, this.selected, value);
          }

          value = this.toUnit(this.item.Element, this.selectedUnit, value);
          
          return value ? value.toFixedGentle(2) : 0;
        },
        setValue(val, i, Element) {
          this.$store.commit('drainage/setValue', {val, i, Element})
        }
    },
    created() {
      if(this.item.types) {
        this.selected = this.item.types[0].label;
      }
    },
    watch: {
      '$route.params.id': {
        handler: function(id) {
          if(this.item.types && !this.item.TargetValues) {
            this.selected = this.item.types[0].label;
          }
        }
      }
    }
}
</script>

<style lang="scss" scoped>
.disabled {
  filter: blur(4px);
  pointer-events: none;
}

.item {
    position: relative;
    border-top: 1px #d6d6d6 solid;
    &:nth-child(2),
    &:nth-child(5) {
      border: none;
    }
    td {
        padding: 20px 0;
        &:last-child {
            padding-right: 15px;
        }
        .drainage-nut-app-sel {
            width: 115px;
        }
        .drainage-num-input {
            width: 130px;
        }
        .as-default {
          padding-left: 12px;
        }
    }
}

.table-loader {
  position: absolute;
  width: 40px;
  top: calc(50% - 20px);
  left: calc(50% - 20px);
  z-index: 100;
}

</style>